var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "#262949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6129 1.80645C3.6129 2.80413 2.80413 3.6129 1.80645 3.6129C0.808776 3.6129 0 2.80413 0 1.80645C0 0.808776 0.808776 0 1.80645 0C2.80413 0 3.6129 0.808776 3.6129 1.80645ZM3.6129 8C3.6129 8.99767 2.80413 9.80645 1.80645 9.80645C0.808776 9.80645 0 8.99767 0 8C0 7.00232 0.808776 6.19355 1.80645 6.19355C2.80413 6.19355 3.6129 7.00232 3.6129 8ZM1.80645 16C2.80413 16 3.6129 15.1912 3.6129 14.1935C3.6129 13.1959 2.80413 12.3871 1.80645 12.3871C0.808776 12.3871 0 13.1959 0 14.1935C0 15.1912 0.808776 16 1.80645 16Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnUnion);
export default __webpack_public_path__ + "static/media/icn-union.29b93ef711ef6208b4202034af037153.svg";
export { ForwardRef as ReactComponent };